 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","EducationalAdd":"EducationalAdd","Redirect":"Redirect","CourseProgress":"CourseProgress","CourseShop":"CourseShop","CourseLibrary":"CourseLibrary","CourseLibrarySection":"CourseLibrarySection","CourseResources":"CourseResources","MySalesRecord":"MySalesRecord","MySalesRecordAdd":"MySalesRecordAdd","OfflineRecordReview":"OfflineRecordReview","ProductManage":"ProductManage","CourseLibraryAdd~CourseLibraryEdit":"CourseLibraryAdd~CourseLibraryEdit","CourseLibraryEdit":"CourseLibraryEdit","CourseResourcesAdd~CourseResourcesEdit":"CourseResourcesAdd~CourseResourcesEdit","CourseResourcesAdd":"CourseResourcesAdd","CourseResourcesEdit":"CourseResourcesEdit","Dashboard":"Dashboard","EducationalBatchAdd":"EducationalBatchAdd","EducationalEdit":"EducationalEdit","CollegeRealName":"CollegeRealName","CourseLibraryAdd":"CourseLibraryAdd","ProductManageAdd":"ProductManageAdd"}[chunkId]||chunkId) + "." + {"404":"d361e4a0","EducationalAdd":"5c45aec6","Redirect":"620ea2dd","chunk-035db77e":"fabd4f0c","chunk-0a79f4fd":"5981f010","chunk-0b7007c4":"1ec0d6b0","chunk-0dae4bdd":"317e8f6e","chunk-10fe43d0":"176b1c22","chunk-17da3dbd":"d0b368c2","chunk-18d8b19a":"e7b0ae3a","chunk-1d8d7e4b":"65ed4444","CourseProgress":"ad67d47b","CourseShop":"9ac5da72","chunk-086b13f8":"4ecbfefa","chunk-0af6d9e4":"2973a099","chunk-178edd1e":"21ff225c","chunk-1a67b6fe":"70ba9adc","chunk-1ba4ce36":"bd8ed6e9","chunk-249cb905":"7408bf5f","chunk-2d21b84f":"3d596c25","chunk-421a9138":"4822f5ab","chunk-42c16a38":"da4f4b52","chunk-49ed69cf":"305d346a","chunk-6195dbcc":"45ac71c2","chunk-65e543f1":"07316265","chunk-69bf008d":"c57e966b","chunk-6e3e8858":"896bff48","chunk-7ba918b4":"908e0a0d","chunk-9e9c9b90":"a203e6ea","CourseLibrary":"de453997","CourseLibrarySection":"368caa11","CourseResources":"0e0a1188","MySalesRecord":"676101d1","MySalesRecordAdd":"fbda1a73","OfflineRecordReview":"d07e0ef5","ProductManage":"a2c0121c","chunk-0f0899ad":"2cd7d054","chunk-13a8e6ce":"f3dac8a5","chunk-18c09586":"53b20572","chunk-2d0bdf75":"b25007d1","chunk-03cf41e6":"798f3e73","chunk-371e95c5":"4e238ed7","chunk-3b5e28ee":"e2aaf10f","chunk-3dad8a61":"631e0495","CourseLibraryAdd~CourseLibraryEdit":"75c49c86","CourseLibraryEdit":"b6eb30d1","CourseResourcesAdd~CourseResourcesEdit":"b0b605dc","CourseResourcesAdd":"1fc051e0","chunk-5012b44c":"eab385f6","chunk-545e8e3b":"8fedf13c","chunk-5e216d68":"4722cf2e","chunk-66c70f46":"c59ca839","chunk-6918ebec":"2abd5f65","chunk-7d13d995":"1297d4f1","chunk-91e5fc52":"eaf2a359","chunk-ac70ea78":"4fb84b90","chunk-c45c35ea":"e7c61439","chunk-d207a5dc":"e401376c","chunk-fb097236":"6f8c2b29","chunk-26a7064a":"28e968c1","chunk-271fa51b":"6b2c226c","chunk-4bda0f44":"68ff6659","chunk-4f60dd7d":"75a51afa","chunk-4f9d2732":"7330c9b6","chunk-5ba95088":"6c9c87c9","chunk-63138a9b":"e03a3e39","chunk-64e16a78":"ee48915e","chunk-6aa9ee7e":"b7416ccb","chunk-755964c0":"64ac74e6","chunk-795a1fde":"d3bf152a","CourseResourcesEdit":"4321f401","Dashboard":"50adcb5b","EducationalBatchAdd":"dcfa33ef","EducationalEdit":"1c0e22ea","chunk-057415f8":"80142118","CollegeRealName":"a767c81d","chunk-66483de4":"f1c42aad","chunk-2d0b1e31":"8075a2e8","chunk-2d0b276b":"927f281d","CourseLibraryAdd":"06eb3ce8","ProductManageAdd":"f4ea1ece","chunk-028c57a6":"32f29161","chunk-14687e27":"0daf28ac","chunk-3127edc9":"3d6fdd39","chunk-356beb05":"fd16cff6","chunk-c02ef60e":"d7c050ed","chunk-6c57cafe":"559c7e92","chunk-7b867806":"c9ef51b6","chunk-4ce4f7c7":"7d9faf53","chunk-7688c559":"34cbef95","chunk-7f42c746":"757aedff","chunk-cb33f7da":"4a26faf8","chunk-f974978e":"31fd3720","chunk-5f63ce30":"c6c87aa8","chunk-ffe82ea8":"2b42e2e3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"EducationalAdd":1,"chunk-035db77e":1,"chunk-0a79f4fd":1,"chunk-0b7007c4":1,"chunk-0dae4bdd":1,"chunk-10fe43d0":1,"chunk-17da3dbd":1,"chunk-18d8b19a":1,"chunk-1d8d7e4b":1,"CourseProgress":1,"CourseShop":1,"chunk-086b13f8":1,"chunk-0af6d9e4":1,"chunk-178edd1e":1,"chunk-249cb905":1,"chunk-421a9138":1,"chunk-42c16a38":1,"chunk-6195dbcc":1,"chunk-65e543f1":1,"chunk-69bf008d":1,"chunk-6e3e8858":1,"chunk-7ba918b4":1,"CourseLibrary":1,"CourseLibrarySection":1,"CourseResources":1,"MySalesRecord":1,"MySalesRecordAdd":1,"OfflineRecordReview":1,"chunk-0f0899ad":1,"chunk-03cf41e6":1,"chunk-371e95c5":1,"chunk-3b5e28ee":1,"CourseLibraryAdd~CourseLibraryEdit":1,"CourseLibraryEdit":1,"CourseResourcesAdd~CourseResourcesEdit":1,"CourseResourcesAdd":1,"chunk-5012b44c":1,"chunk-66c70f46":1,"chunk-6918ebec":1,"chunk-91e5fc52":1,"chunk-ac70ea78":1,"chunk-d207a5dc":1,"chunk-fb097236":1,"chunk-26a7064a":1,"chunk-271fa51b":1,"chunk-4bda0f44":1,"chunk-4f60dd7d":1,"chunk-4f9d2732":1,"chunk-5ba95088":1,"chunk-63138a9b":1,"chunk-64e16a78":1,"chunk-6aa9ee7e":1,"chunk-755964c0":1,"chunk-795a1fde":1,"Dashboard":1,"EducationalBatchAdd":1,"EducationalEdit":1,"chunk-057415f8":1,"CollegeRealName":1,"chunk-66483de4":1,"ProductManageAdd":1,"chunk-028c57a6":1,"chunk-14687e27":1,"chunk-3127edc9":1,"chunk-356beb05":1,"chunk-c02ef60e":1,"chunk-6c57cafe":1,"chunk-4ce4f7c7":1,"chunk-7688c559":1,"chunk-7f42c746":1,"chunk-cb33f7da":1,"chunk-f974978e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","EducationalAdd":"EducationalAdd","Redirect":"Redirect","CourseProgress":"CourseProgress","CourseShop":"CourseShop","CourseLibrary":"CourseLibrary","CourseLibrarySection":"CourseLibrarySection","CourseResources":"CourseResources","MySalesRecord":"MySalesRecord","MySalesRecordAdd":"MySalesRecordAdd","OfflineRecordReview":"OfflineRecordReview","ProductManage":"ProductManage","CourseLibraryAdd~CourseLibraryEdit":"CourseLibraryAdd~CourseLibraryEdit","CourseLibraryEdit":"CourseLibraryEdit","CourseResourcesAdd~CourseResourcesEdit":"CourseResourcesAdd~CourseResourcesEdit","CourseResourcesAdd":"CourseResourcesAdd","CourseResourcesEdit":"CourseResourcesEdit","Dashboard":"Dashboard","EducationalBatchAdd":"EducationalBatchAdd","EducationalEdit":"EducationalEdit","CollegeRealName":"CollegeRealName","CourseLibraryAdd":"CourseLibraryAdd","ProductManageAdd":"ProductManageAdd"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","EducationalAdd":"51a67209","Redirect":"31d6cfe0","chunk-035db77e":"a510f63d","chunk-0a79f4fd":"9a92987d","chunk-0b7007c4":"c7700b1f","chunk-0dae4bdd":"60553bce","chunk-10fe43d0":"09f7a9e1","chunk-17da3dbd":"a636997b","chunk-18d8b19a":"a5e84c07","chunk-1d8d7e4b":"4f3ed833","CourseProgress":"0e031a2e","CourseShop":"a0597b5b","chunk-086b13f8":"b537f056","chunk-0af6d9e4":"bac369e5","chunk-178edd1e":"ac0fff2f","chunk-1a67b6fe":"31d6cfe0","chunk-1ba4ce36":"31d6cfe0","chunk-249cb905":"cdd3e2fa","chunk-2d21b84f":"31d6cfe0","chunk-421a9138":"31cf57fc","chunk-42c16a38":"24cef01e","chunk-49ed69cf":"31d6cfe0","chunk-6195dbcc":"3c9e2ec8","chunk-65e543f1":"db5551bb","chunk-69bf008d":"b89c7345","chunk-6e3e8858":"9fb7f9c5","chunk-7ba918b4":"c3ae5ddc","chunk-9e9c9b90":"31d6cfe0","CourseLibrary":"526193c3","CourseLibrarySection":"e659097e","CourseResources":"5f2aa0f3","MySalesRecord":"4f5a0087","MySalesRecordAdd":"0543b951","OfflineRecordReview":"8ea24197","ProductManage":"31d6cfe0","chunk-0f0899ad":"2309b5f4","chunk-13a8e6ce":"31d6cfe0","chunk-18c09586":"31d6cfe0","chunk-2d0bdf75":"31d6cfe0","chunk-03cf41e6":"67e6e08b","chunk-371e95c5":"762ddb1b","chunk-3b5e28ee":"7735eea2","chunk-3dad8a61":"31d6cfe0","CourseLibraryAdd~CourseLibraryEdit":"fa1666ea","CourseLibraryEdit":"8eb78380","CourseResourcesAdd~CourseResourcesEdit":"7fef7831","CourseResourcesAdd":"0dbc95c8","chunk-5012b44c":"911c7287","chunk-545e8e3b":"31d6cfe0","chunk-5e216d68":"31d6cfe0","chunk-66c70f46":"5781f7f7","chunk-6918ebec":"72944051","chunk-7d13d995":"31d6cfe0","chunk-91e5fc52":"7be0bb69","chunk-ac70ea78":"ea6e3f66","chunk-c45c35ea":"31d6cfe0","chunk-d207a5dc":"5dfb18b8","chunk-fb097236":"3a3c8f4b","chunk-26a7064a":"5be8cb9b","chunk-271fa51b":"a2dbe739","chunk-4bda0f44":"97866dd9","chunk-4f60dd7d":"1f28618b","chunk-4f9d2732":"fed0a484","chunk-5ba95088":"76dbd241","chunk-63138a9b":"908d72f6","chunk-64e16a78":"16cd6d1e","chunk-6aa9ee7e":"a7b6ebb4","chunk-755964c0":"37f7f887","chunk-795a1fde":"45afe22f","CourseResourcesEdit":"31d6cfe0","Dashboard":"bd36d719","EducationalBatchAdd":"76dbbb22","EducationalEdit":"e0a7bb4c","chunk-057415f8":"abbfc6a0","CollegeRealName":"b825d8f1","chunk-66483de4":"5c0003a8","chunk-2d0b1e31":"31d6cfe0","chunk-2d0b276b":"31d6cfe0","CourseLibraryAdd":"31d6cfe0","ProductManageAdd":"0bded21f","chunk-028c57a6":"ad8b3037","chunk-14687e27":"9a430bd9","chunk-3127edc9":"e7c9c5b3","chunk-356beb05":"13548b22","chunk-c02ef60e":"1e3e71b8","chunk-6c57cafe":"126fb744","chunk-7b867806":"31d6cfe0","chunk-4ce4f7c7":"0c5116d5","chunk-7688c559":"11f68d84","chunk-7f42c746":"41d7cd38","chunk-cb33f7da":"3a07137c","chunk-f974978e":"8cae3f76","chunk-5f63ce30":"31d6cfe0","chunk-ffe82ea8":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
